import * as React from "react";
import { FinishSignup, ViewMe } from "@njoy/controller";

import { FinishSignupView } from "./ui/FinishSignupView";
import { FinishSignupModal } from "../../components/modals/finishSignupModal";
import Loader from "../../components/loader/Loader";

import * as ROUTES from "../../constants/routes";

interface State {
  visible: boolean;
  step: number;
}

export class C extends React.PureComponent<{}, State> {
  state: State = {
    visible: false,
    step: 0,
  };

  nextStep = () => {
    this.setState(prev => ({ step: prev.step + 1 }));
  };

  prevStep = () => {
    this.setState(prev => ({ step: prev.step - 1 }));
  };

  onFinish = () => {
    window.location.replace(ROUTES.HOME);
  };

  showModal = () => {
    this.setState({ visible: true });
  };

  handleCancel = () => {
    this.setState({ visible: false });
    this.onFinish();
  };

  render() {
    return (
      <div>
        <div className="flex flex-row py-[2rem] px-[1rem] justify-between ">
          <h2 className="text-2xl text-white mt-8 font-bold max-w-[80%]">
            {" "} Enter your Personal Information
          </h2>
          <div className="mt-8">
            <span className="text-sm text-white/60">{this.state.step + 1} of 2</span>
          </div>
        </div>
        <br />

        <FinishSignup>
          {({ submit }) => (
            <FinishSignupView
              onFinish={this.showModal}
              submit={async (values) => {
                const result = await submit(values);
                return result; // Return the full result object for proper handling
              }}
              step={this.state.step}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
            />
          )}
        </FinishSignup>

        <ViewMe>
          {data => {
            if (!data.match) {
              return <Loader center text="Loading..." />;
            }
            return (
              <FinishSignupModal
                visible={this.state.visible}
                onOk={this.handleCancel}
                onCancel={this.handleCancel}
              />
            );
          }}
        </ViewMe>
      </div>
    );
  }
}

export const FinishSignupConnector = C;